import { jsx } from "react/jsx-runtime";
import { ThemeProvider } from "@mui/material";
import { palette } from "../../constants/colors/palette.js";
import { createTheme } from "../../constants/create-theme/create-theme.js";
import { MuiAlert } from "../../themes/alert/alert.js";
import { MuiButton } from "../../themes/button/button.js";
import { MuiCheckbox } from "../../themes/checkbox/checkbox.js";
import { typography, MuiTypography } from "../../themes/typography/typography.js";
import { MuiDialog } from "../../themes/dialog/dialog.js";
import "../../themes/external-theme/external-theme.js";
import { MuiFilledInput } from "../../themes/filled-input/filled-input.js";
import "color-alpha";
import { MuiIconButton } from "../../themes/icon-button/icon-button.js";
import "../../themes/pickers-popper/pickers-popper.js";
import { MuiPopover } from "../../themes/popover/popover.js";
import { MuiRadio } from "../../themes/radio/radio.js";
import { shadows } from "../../themes/shadows/shadows.js";
import { MuiSwitch } from "../../themes/switch/switch.js";
import { MuiTabs } from "../../themes/tabs/tabs.js";
import { MuiTooltip } from "../../themes/tooltip/tooltip.js";
import "@mui/material/styles";
import "../../themes/alert/components/ErrorIcon/ErrorIcon.js";
import "@mui/material/SvgIcon/index.js";
import "../../themes/alert/components/InfoIcon/InfoIcon.js";
import "../../themes/alert/components/SuccessIcon/SuccessIcon.js";
import "../../themes/alert/components/WarningIcon/WarningIcon.js";
import "../../themes/button/styles/external/bordered.styles.js";
import "../../themes/button/styles/external/filled.styles.js";
import "../../themes/button/styles/internal/bordered.styles.js";
import "../../themes/button/styles/internal/borderless.styles.js";
import "../../themes/button/styles/internal/filled.styles.js";
import "../../themes/button/styles/internal/shadowed.styles.js";
import "../../themes/checkbox/components/CheckedIcon/CheckedIcon.js";
import "../../themes/checkbox/components/IndeterminateIcon/IndeterminateIcon.js";
import "../../themes/typography/utils/defaultVariantMapping/defaultVariantMapping.js";
import "../../themes/typography/utils/typographyVariants/typographyVariants.js";
import "../../constants/breakpoints/breakpoints.js";
import "../../themes/form-control-label/form-control-label.js";
const uiLibraryTheme = createTheme({
  palette,
  typography,
  shadows,
  components: {
    MuiButton,
    MuiCheckbox,
    MuiSwitch,
    MuiTabs,
    MuiDialog,
    MuiFilledInput,
    MuiIconButton,
    MuiTypography,
    MuiPopover,
    MuiRadio,
    MuiAlert,
    MuiTooltip
  }
});
const UiLibraryThemeProvider = ({ children }) => /* @__PURE__ */ jsx(ThemeProvider, { theme: uiLibraryTheme, children });
export {
  UiLibraryThemeProvider,
  uiLibraryTheme
};
